import { makeStyles } from '@material-ui/core/styles';
import { reskinStyles } from 'core/components/theme/theme-variant';

const useStyles = makeStyles((theme) => ({
  table: {
    width: '100%',
    '& td, th': {
      padding: '8px 16px'
    }
  },
  headerCell: {
    fontWeight: 600,
    fontSize: '0.75rem',
    color: theme.palette.text.secondary,
    textTransform: 'uppercase',
    letterSpacing: '0.5px'
  },
  tableRow: {
    '&:hover': {
      backgroundColor: theme.palette.action.hover,
      ...reskinStyles(theme, { backgroundColor: theme.colorPalette.beige_50 })
    },
    height: 60
  },
  fileName: {
    color: theme.colors.green_80
  },
  fileNameCell: {
    maxWidth: 300
  },
  fileNameContainer: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'flex-start',
    gap: theme.spacing(0.25)
  },
  originalName: {
    color: theme.palette.text.secondary,
    fontStyle: 'italic',
    wordBreak: 'break-all'
  },
  cell: {
    color: theme.palette.text.primary
  },
  uploadInfo: {
    display: 'flex',
    flexDirection: 'column',
    gap: theme.spacing(0.25)
  },
  uploadedBy: {
    color: theme.palette.text.secondary,
    fontSize: '0.75rem',
    fontStyle: 'italic'
  },
  actionsCell: {
    width: 100
  },
  actions: {
    display: 'flex',
    gap: theme.spacing(0.5)
  },
  actionButton: {
    padding: theme.spacing(0.5),
    '&:hover': {
      backgroundColor: theme.palette.action.hover,
      // Reskin: the icon-button hover, which still shows inside a hovered row.
      ...reskinStyles(theme, { backgroundColor: theme.colorPalette.beige_50 })
    }
  },
  loadingContainer: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    padding: theme.spacing(4),
    gap: theme.spacing(2)
  },
  loadingText: {
    color: theme.palette.text.secondary
  },
  emptyState: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    padding: theme.spacing(4),
    textAlign: 'center'
  },
  emptyText: {
    color: theme.palette.text.secondary
  }
}));

export default useStyles;
